<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="bookingListCard">
          <!-- CARD HEADER BEGIN -->
          <b-card-header header-tag="div">
    				{{ $t('booking.title') }}
    				<div class="card-header-actions">
    					<b-link @click="openBookingWithMode('create')" class="card-header-action btn-setting" style="font-size: 15px" v-if="$can('create', 'warehouse-document')">
    						<i class="fa fa-plus-circle"></i>
    					</b-link>
    				</div>
    			</b-card-header>
          <!-- CARD HEADER END -->

          <!-- CARD BODY BEGIN -->
          <b-card-body>
            <b-tabs @input="tabChanged" v-model="customTabIndex" content-class="mt-3">
    					<b-tab :title="$t('active')" active>
                <b-row class="mb-2">
            			<b-col cols="3">
                    <!-- USER PERMITTED DEPARTMENTS -->
            				<multiselect
            					v-model="selectedDeps"
            					:options="myDepartments"
            					:multiple="true"
            					track-by="id"
            					:show-labels="false"
            					:allow-empty="true"
            					label="name"
            					:placeholder="$t('promo-to-product.department')"
            					class="multiselect-pricing"
            				>
            				</multiselect>
            			</b-col>
                  <b-col cols="2">
            				<b-button @click="fetchBookingDocsLocal(payloadForList)" :disabled="loading" class="pull-right" variant="primary">{{ $t('apply') }}
            				</b-button>
            			</b-col>
                </b-row>
                <div class="table-wrapper table-responsive">
                  <b-table class="generalTableClass mb-2"
                          :items="bookingDocsList"
                          :fields="fieldsForBookingList"
                          hover="hover" striped="striped" bordered="bordered"
                          :current-page="payloadForList.page"
                          :per-page="0"
                          responsive show-empty
                  >
                    <!-- EMPTY SLOT FOR TABLE -->
    								<template slot="empty" slot-scope="scope">
    									<h4>{{ $t('empty') }}</h4>
    								</template>
    								<!-- EMPTY SLOT FOR TABLE -->

                    <template slot="actions" slot-scope="data">
    									<div>
    										<b-link @click="showBookingItemsById(data.item)">
    											<i class="fa fa-eye"></i>
    										</b-link>
    										<b-link v-if="data.item.status == 'SUSPENDED'" @click="editBookingDoc(data.item)">
    											<i class="fa fa-edit"></i>
    										</b-link>

    										<b-link :key="data.item.id + 'delete'"
    													  :id="'popOverDelete'+data.item.id"
    													  @click="showConfirmForDelete(data.item.id)"
  											>
  												<i class="fa fa-trash"></i>
  											</b-link>
  											<b-popover
  												:key="data.item.id + 'popover'"
  												:target="'popOverDelete'+data.item.id"
  												placement="left"
  												:ref="'popover'+data.item.id"
  												class="refDeleteConfirm"
  											>
  												<template slot="title">
  													<b-button @click="closeConfirm(data.item.id)" class="close"
  															  aria-label="Close" style="margin-left: 5px">
  														<span class="d-inline-block" aria-hidden="true">&times;</span>
  													</b-button>
  													{{ $t('want_to_delete?') }}
  												</template>

  												<div>
  													<div class="row mt-1">
  														<div class="col-6">
  															<b-button variant="outline-danger" size="sm" block
  																	  @click="closeConfirm(data.item.id)"> {{ $t('actions.no') }}
  															</b-button>
  														</div>
  														<div class="col-6">
  															<b-button variant="outline-success" size="sm" block
  																	  @click="deleteBookingDoc(data.item.id)">{{ $t('actions.yes') }}
  															</b-button>
  														</div>
  													</div>
  												</div>
  											</b-popover>
    									</div>

    								</template>
                  </b-table>
                  <nav>
    								<b-pagination :total-rows="bookingDocsTotal"
                                  :per-page="payloadForList.limit"
                                  v-model="payloadForList.page"
                                  :prev-text="$t('pagination.prev')"
                                  :next-text="$t('pagination.next')"
                                  hide-goto-end-buttons />
    							</nav>
    							<div v-if="loading" class="spinner-wrapper">
    								<b-spinner variant="primary"></b-spinner>
    							</div>
                </div>
    					</b-tab>
    				</b-tabs>
          </b-card-body>
          <!-- CARD BODY END -->
        </b-card>
      </b-col>

      <!-- MODAL FOR VIEWING BOOKING ITEMS -->
      <b-modal v-model="showBookingItemsModal" size="xl" hide-footer>
        <template v-slot:modal-title>
          {{ $t('sidebar.warehouse-management.product-view') }} - <strong>{{ itemsModalDocNumber }}</strong> ,
          {{ $t('transaction.contragentName') }}: <strong>{{ itemsModalDocContragent }}</strong>
        </template>
        <booking-items-table></booking-items-table>
      </b-modal>

      <!-- VS-SIDEBAR FOR CREATING AND EDITING BOOKING DOC -->
      <vs-sidebar :click-not-close="true"
                  position-right parent="body"
                  default-index="1" color="primary"
                  class="create-modal-wh" spacer
                  v-model="bookingSidebar.open"
      >
    		<b-container>
    			<BookingCreateForm @close="closeSidebar()"
                            v-if="bookingSidebar.open"
                            :mode="bookingSidebar.mode"
                            :edit-item="currentDoc"
                            section="BOOKING"
                            @saved="docSaved"
                            @docSuspended="docSuspended(1, $event)"
          >
          </BookingCreateForm>
    		</b-container>
    	</vs-sidebar>
    </b-row>
  </b-container>
</template>

<script>
import BookingCreateForm from './components/BookingCreateForm'
import BookingItemsTable from './components/BookingItemsTable'
import Vue from 'vue'
import {mapActions, mapGetters, mapState} from "vuex";
import Multiselect from 'vue-multiselect'

export default {
  name: "BookingList",

  components: {
    BookingCreateForm,
    BookingItemsTable,
    Multiselect
	},

  data() {
    return {
      selectedDeps: [],
      itemsModalDocNumber: '',
      itemsModalDocContragent: '',
      showBookingItemsModal: false,
      customTabIndex: 0,
      payloadForList: {
        page: 1,
        limit: 20,
        depIds: []
      },
      bookingSidebar: {
        mode: 'create',
        open: false
      }
    }
  },

  // COMPUTED PROPERTIES
  computed: {
    ...mapState(['userDepCurrencyName', 'userDepId']),
    ...mapState('booking', [
      'bookingDocsList', 'bookingDocsTotal', 'loading',
      'fieldsForBookingList', 'currentDoc', 'currentBookingItems',
      'bookingError', 'currentDocSaleType'
    ]),
    ...mapGetters('departments', [
      'myDepartments'
    ]),
  },

  // METHODS
  methods: {
    ...mapActions('booking', [
      'fetchBookingDocs', 'getBookingDocById', 'getBookingItemsByDocId', 'deleteBookingDocById'
    ]),
    ...mapActions('departments', ['fetchMyDepartments']),

    notifyBookingError() {
      if (this.bookingError.boolean) {
        this.$vs.notify({
          title: this.$t('words.error'),
          text: this.bookingError.message,
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        })
        return true;
      } else {
        return false;
      }
    },
    async fetchBookingDocsLocal() {
      if (this.payloadForList.depIds.length == 0) {
				this.$vs.notify({
					title: 'Пожалуйста выберите Отдел',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			} else {
        await this.fetchBookingDocs(this.payloadForList);
      }
    },
    async docSaved(docId) {
      this.payloadForList.page = 1;
      await this.fetchBookingDocsLocal(this.payloadForList)
    },
    async docSuspended() {
      this.payloadForList.page = 1;
      await this.fetchBookingDocsLocal(this.payloadForList)
    },
    async showBookingItemsById(doc) {
      await this.$store.commit('booking/setCurrentDocCurrency', doc.depCurrencyName ? doc.depCurrencyName : this.userDepCurrencyName);
      let docDep = this.myDepartments.find(dep => {
        return dep.id == doc.departmentId;
      });
      await this.$store.commit('booking/setCurrentDocSaleType', docDep.saleType);
      this.showBookingItemsModal = true;
      this.itemsModalDocNumber = doc.regNumber;
      this.itemsModalDocContragent = doc.contragentName;
      await this.getBookingItemsByDocId(doc.id)
    },
    async deleteBookingDoc(id) {
      this.closeConfirm(id);
      await this.deleteBookingDocById(id);
      if (!this.notifyBookingError()) {
        await this.fetchBookingDocsLocal();
      }
    },
    showConfirmForDelete(id) {
      let refName = 'popover' + id;
      this.$refs[refName].$emit('open');
    },
    closeConfirm(id) {
      let refName = 'popover' + id;
      this.$refs[refName].$emit('close');
    },
    openBookingWithMode(mode = 'create') {
      this.bookingSidebar.mode = mode;
      this.bookingSidebar.open = true;
    },
    closeSidebar() {
      this.bookingSidebar.open = false
    },
    async editBookingDoc(editDoc) {
      await this.getBookingItemsByDocId(editDoc.id);
      if (this.bookingError.boolean) {
        this.$vs.notify({
          title: this.$t('words.error'),
          text: this.bookingError.message,
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        })
      } else {
        Vue.set(editDoc, "bookingItemDtos", this.currentBookingItems)
        // editDoc.bookingItemDtos = this.currentBookingItems;
        this.$store.commit('booking/setCurrentDoc', editDoc);
  			this.openBookingWithMode('edit')
      }
		},
    setColumns() {
			this.fields = this.filterColumns(this.fieldsForBookingList);
		},
    filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},
    tabChanged(e) {

    }
  },

  // CREATED HOOK
  async created() {
    await this.fetchMyDepartments();
    let userDep = await this.myDepartments.find(el => el.id == this.userDepId);
    await this.selectedDeps.push(userDep);
    await this.fetchBookingDocsLocal(this.payloadForList);
  },

  // MOUNTED HOOK
  mounted() {
    this.setColumns();
  },

  // WATCHERS
  watch: {
    'selectedDeps': {
      deep: true,
      handler(newValue) {
        this.payloadForList.depIds = [];
        newValue.forEach(dep => {
          this.payloadForList.depIds.push(dep.id);
        })
      }
    },
    'payloadForList.page': {
			async handler() {
				await this.fetchBookingDocsLocal(this.payloadForList)
			}
		}
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
  .table-wrapper {
  	position: relative;
  	padding: 5px;
  }

  .spinner-wrapper {
  	position: absolute;
  	background: rgba(32, 28, 32, 0.49);
  	left: 0;
  	right: 0;
  	text-align: center;
  	top: 0;
  	bottom: 0;
  	padding-top: 35px;
  	z-index: 5;
  }
</style>
